import { ActionModal } from '@atoms/Modals';
import React from 'react';
import { Button } from 'react-bootstrap';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';
import { FormDataType } from './FormDataType';

type Props = {
    onSubmitStart: any;
};

const defaultValues: FormDataType = {
    id: 0,
    statusKbn: '1',
    updateUser: '',
    timestamp: 0
};

const ShowForm = (props: Props) => {
    const { onSubmitStart } = props;
    const { handleSubmit, reset } = useForm<FormDataType>({ defaultValues });
    const onSubmit: SubmitHandler<FormDataType> = (data: FormDataType) => {
        reset();
        onSubmitStart(data);
    };
    return (
        <FormWithStyled>
            <ActionModal
                title='受付メッセージ対応'
                body='対応状況を「済」にします。よろしいですか？'
                buttonText='対応済'
                buttonStyle='btn-warning'
                element={<Button
                    variant='primary'
                    onClick={handleSubmit(onSubmit)}
                    >はい</Button>
                }
                disabled={false}
            />
            
        </FormWithStyled>
    );
};

const FormWithStyled = styled.div`
    margin: 0;
`


export default ShowForm;